/* Ambient event toasts — real notifications (mentions, knocks, …). Replaces the
   prototype's imperative Atrium.toast() with a small reactive queue. */
import { defineStore } from 'pinia'

export interface ToastOpts {
  icon?: string
  color?: string
  title: string
  text?: string
  action?: string
  onAction?: () => void
  sticky?: boolean
  ms?: number
}

export interface Toast extends ToastOpts {
  id: number
}

let seq = 0

export const useToasts = defineStore('toasts', {
  state: () => ({ items: [] as Toast[] }),
  actions: {
    push(opts: ToastOpts): number {
      const id = ++seq
      this.items.push({ ...opts, id })
      if (!opts.sticky) {
        setTimeout(() => this.dismiss(id), opts.ms || 4200)
      }
      return id
    },
    dismiss(id: number) {
      const i = this.items.findIndex((t) => t.id === id)
      if (i >= 0) this.items.splice(i, 1)
    },
    fire(id: number) {
      const t = this.items.find((x) => x.id === id)
      if (t?.onAction) t.onAction()
      this.dismiss(id)
    },
  },
})
